export default "__VITE_ASSET__DQztYlDj__"